<template>
  <div class="user-detail-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
            员工档案
          </div>
          <div class="card-content">
            <el-row>
              <el-row style="text-align: center;margin-bottom: 20px;">
                <el-image fit="cover" style="max-width:100px;max-height: 100px;border-radius:50%" :src="userData.user.photourl"/>
              </el-row>
              <el-col :span="5" :offset="1">
                <div class="user-item"><i class="el-icon-user-solid"/>姓名：<span>{{userData.user.dName}}</span></div>
                <div class="user-item" v-if="userData.user.dEmail!==''">
                  <el-tooltip placement="top">
                    <div slot="content">
                      {{userData.user.dEmail}}
                    </div>
                    <span style="text-overflow:ellipsis; overflow: hidden;white-space: nowrap;"><i class="el-icon-message"/>邮箱：<span>{{userData.user.dEmail}}</span></span>
                  </el-tooltip>
                </div>
                <div class="user-item" v-if="userData.user.dEmail===''"><i class="el-icon-message"/>邮箱：<span>未填写</span></div>
                <div class="user-item"><i class="el-icon-office-building"/>公司：<span>{{userData.user.group_name}}</span></div>
                <div class="user-item"><i class="el-icon-timer"/>学习时长：<span>{{userData.studyTime}} </span></div>
                <div class="user-item"><i class="el-icon-time"/>注册时间：<span>{{userData.user.dRegtime}}</span></div>
              </el-col>
              <el-col :span="5" :offset="1">
                <div class="user-item"><i class="el-icon-male"/>性别：<span>{{userData.user.dSex}}</span></div>
                <div class="user-item"><i class="el-icon-phone"/>手机号：<span>{{userData.user.dUsername}}</span></div>
                <div class="user-item" style="white-space:normal;"><i class="el-icon-position"/>
                  部门：
                  <span v-if="isEditDept">
                    <el-cascader
                      style="width: 50%"
                      v-model="deptid"
                      :options="deptoptions"
                      :props="{ checkStrictly: true }"
                      :show-all-levels="false"
                      filterable></el-cascader>
                  </span>
                  <span v-else>{{userData.user.dept_name}}</span>
                  <span style="margin-left: 15px;">
                    <el-button style="font-size: 13px;color: rgb(255,59,48)" type="text" @click="closeUserDept" v-if="isEditDept">取消</el-button>
                    <el-button style="font-size: 13px;" type="text" @click="editUserDept" v-if="isEditDept">确定</el-button>
                    <el-button style="font-size: 13px;" type="text" @click="changeUserDept" v-else>修改</el-button>
                  </span>
                </div>
                <div class="user-item" v-if="userData.auths!==''">
                  <el-tooltip placement="top">
                    <div slot="content">
                      {{userData.auths}}
                    </div>
                    <span style="text-overflow:ellipsis; overflow: hidden;white-space: nowrap;">已获得证书：<span>{{userData.auths}}</span></span>
                  </el-tooltip>
                </div>
                <div class="user-item" v-if="userData.auths===''">已获得证书：<span>暂无</span></div>
              </el-col>
              <el-col :span="5" :offset="1">
                <div class="user-item" v-if="userData.user.dBirthday!==''"><i class="el-icon-potato-strips"/>生日：<span>{{userData.user.dBirthday}}<span v-if="userData.dBdtype===0" style="color: #20a0ff">(公历)</span><span style="color: #20a0ff" v-else>(农历)</span></span></div>
                <div class="user-item" v-if="userData.user.dBirthday===''"><i class="el-icon-potato-strips"/>生日：<span>未填写</span></div>
                <div class="user-item" v-if="userData.user.dTel!==''"><i class="el-icon-phone-outline"/>联系电话：<span>{{userData.user.dTel}}</span></div>
                <div class="user-item" v-if="userData.user.dTel===''"><i class="el-icon-phone-outline"/>联系电话：<span>未填写</span></div>
                <div class="user-item" style="white-space:normal;"><i class="el-icon-collection-tag"/>
                  职位：
                  <span v-if="isEditPosition">
                    <el-cascader
                      style="width: 50%;"
                      v-model="positionid"
                      :options="positionoptions"
                      :show-all-levels="false"
                      filterable></el-cascader>
                  </span>
                  <span v-else>{{userData.user.position_name}}</span>
                  <span style="margin-left: 15px;">
                    <el-button style="font-size: 13px;color: rgb(255,59,48)" type="text" @click="closeUserPosition" v-if="isEditPosition">取消</el-button>
                    <el-button style="font-size: 13px;" type="text" @click="editUserPosition" v-if="isEditPosition">确定</el-button>
                    <el-button style="font-size: 13px;" type="text" @click="changeUserPosition" v-else>修改</el-button>
                  </span>
                </div>
                <div class="user-item" v-if="userData.studyTasks!==''">
                  <el-tooltip placement="top">
                    <div slot="content">
                      {{userData.studyTasks}}
                    </div>
                    <span style="text-overflow:ellipsis; overflow: hidden;white-space: nowrap;">已完成学习任务：<span>{{userData.studyTasks}}</span></span>
                  </el-tooltip>
                </div>
                <div class="user-item" v-if="userData.studyTasks===''">已完成学习任务：<span>暂无</span></div>
              </el-col>
              <el-col :span="5" :offset="1">
                <div class="user-item" v-if="userData.user.dProvince!=='' && userData.user.dCity!=='' && userData.user.dCounty!==''"><i class="el-icon-house"/>籍贯：<span>{{userData.user.dProvince}}/{{userData.user.dCity}}/{{userData.user.dCounty}}</span></div>
                <div class="user-item" v-if="userData.user.dProvince==='' && userData.user.dCity==='' && userData.user.dCounty===''"><i class="el-icon-house"/>籍贯：<span>未填写</span></div>
                <div class="user-item" v-if="userData.user.dProvince!=='' && userData.user.dCity==='' && userData.user.dCounty===''"><i class="el-icon-house"/>籍贯：<span>{{userData.user.dProvince}}</span></div>
                <div class="user-item" v-if="userData.user.dProvince!=='' && userData.user.dCity!=='' && userData.user.dCounty===''"><i class="el-icon-house"/>籍贯：<span>{{userData.user.dProvince}}/{{userData.user.dCity}}</span></div>
                <div class="user-item" v-if="userData.user.dWchat!==''"><svg-icon icon-class="wechat" style="color:#99a9bf;width: 13px;margin-right: 5px;" />微信：<span>{{userData.user.dWchat}}</span></div>
                <div class="user-item" v-if="userData.user.dWchat===''"><svg-icon icon-class="wechat" style="color:#99a9bf;width: 13px;margin-right: 5px;" />微信：<span>未填写</span></div>
                <div class="user-item"><i class="el-icon-coin"/>积分：<span>{{userData.user.dPeriod}}</span></div>
                <div class="user-item" v-if="userData.postMaps!==''">
                  <el-tooltip placement="top">
                    <div slot="content">
                      {{userData.postMaps}}
                    </div>
                    <span style="text-overflow:ellipsis; overflow: hidden;white-space: nowrap;">已完成岗位地图：<span>{{userData.postMaps}}</span></span>
                  </el-tooltip>
                </div>
                <div class="user-item" v-if="userData.postMaps===''">已完成岗位地图：<span>暂无</span></div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="23" :offset="1">
                <div class="user-item">
                  用户状态：
                  <span v-if="userData.user.dMark===1 && isEdit===0">
                    正常
                  </span>
                  <span v-if="userData.user.dMark===3 && isEdit===0">
                    未激活
                  </span>
                  <span v-if="userData.user.dMark===4 && isEdit===0">
                    已离职
                  </span>
                  <span v-if="userData.user.dMark===0 && isEdit===0">
                    已停用
                  </span>
                  <el-radio-group v-model="userMark" size="mini" v-if="isEdit===1">
                    <el-radio :label="0">停用</el-radio>
                    <el-radio :label="1">正常</el-radio>
                    <el-radio :label="3" disabled>未激活</el-radio>
                    <el-radio :label="4">已离职</el-radio>
                  </el-radio-group>
                  <span style="margin-left: 15px;">
                    <el-button style="font-size: 13px;" type="text" @click="changeUserMark" v-if="isEdit===0">修改</el-button>
                    <el-button style="font-size: 13px;" type="text" @click="editUserMark" v-if="isEdit===1">确定</el-button>
                  </span>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { editUserDept, editUserPosition, getUserDetail } from '@/api/work'
import { editUserMark } from '@/api/work'
import { getDeptTreeByGroupId, getGroupTree, getPositionTree } from '@/api/pub'

export default {
  name: 'user_detail',
  computed: {
    user: getUser
  },
  created() {
    this.tempRoute = Object.assign({}, this.$route)
    this.uid = this.$route.params && this.$route.params.uid
    this.getUserDetail()
    // 获取职位列表
    getPositionTree().then(response => {
      if (!response.success) {
        this.$message({
          type: 'error',
          message: response.msg
        })
      } else {
        this.positionoptions = response.data
        let data = []
        for (const item of this.positionoptions) {
          if (item.value === 50) {
            for (const i of item.children) {
              if (i.value === 67) {
                data = i.children
              }
            }
          }
        }
        this.positionoptionsCopy = data
      }
    }).catch(() => {
    })
    // 获取部门列表
    getGroupTree({ groupid: this.user.dGroupid }).then(response => {
      if (!response.success) {
        this.$message({
          type: 'error',
          message: response.msg
        })
      } else {
        this.deptoptions = response.data
      }
    }).catch(() => {
    })
  },
  data() {
    return {
      loading: false,
      isEdit: 0,
      userData: {
        user: {},
        authList: [],
        postMapList: [],
        studyTaskList: [],
        auths: '',
        postMaps: '',
        studyTasks: '',
        studyTime: ''
      },
      uid: '',
      userMark: 0,
      positionoptions: [],
      positionoptionsCopy: [],
      isEditPosition: false,
      positionid: '',
      oldPosition: '', // 判断同页面多次更改
      isEditDept: false,
      deptoptions: [],
      deptid: '',
      olddeptid: ''
    }
  },
  methods: {
    getUserDetail() {
      this.loading = true
      getUserDetail({ userid: this.uid }).then(response => {
        this.userData.user = response.data.user
        this.userMark = this.userData.user.dMark
        if (this.userData.user.photourl === '') {
          if (this.userData.user.dSex === '男') {
            this.userData.user.photourl = '@/assets/login/photo_men.png'
          } else {
            this.userData.user.photourl = '@/assets/login/photo_women.png'
          }
        }
        this.userData.studyTime = this.formatSeconds(this.userData.user.dPeriod)
        this.userData.authList = response.data.authList
        if (this.userData.authList.length > 0) {
          for (let i = 0; i < this.userData.authList.length; i++) {
            if (i < this.userData.authList.length - 1) {
              this.userData.auths = this.userData.authList[i].dName + '、'
            } else {
              this.userData.auths = this.userData.authList[i].dName
            }
          }
        }
        this.userData.postMapList = response.data.postmapList
        if (this.userData.postMapList.length > 0) {
          debugger
          for (let i = 0; i < this.userData.postMapList.length; i++) {
            if (i < this.userData.postMapList.length - 1) {
              this.userData.postMaps = this.userData.postMapList[i].name + '、'
            } else {
              this.userData.postMaps = this.userData.postMapList[i].name
            }
          }
        }
        this.userData.studyTaskList = response.data.taskList
        if (this.userData.studyTaskList.length > 0) {
          for (let i = 0; i < this.userData.studyTaskList.length; i++) {
            if (i < this.userData.studyTaskList.length - 1) {
              this.userData.studyTasks = this.userData.studyTaskList[i].name + '、'
            } else {
              this.userData.studyTasks = this.userData.studyTaskList[i].name
            }
          }
        }
        this.loading = false
        this.setTagsViewTitle()
      })
    },
    setTagsViewTitle() {
      const route = Object.assign({}, this.tempRoute, { title: `员工档案 - ${this.userData.user.dName}` })
      this.$store.dispatch('tagsView/updateVisitedView', route)
    },
    changeUserMark() {
      this.isEdit = 1
    },
    editUserMark() {
      const data = {
        userid: this.uid,
        mark: this.userMark
      }
      editUserMark(data).then(response => {
        this.userData.user.dMark = this.userMark
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
        this.isEdit = 0
      })
    },
    changeUserPosition() {
      this.isEditPosition = true
    },
    editUserPosition() {
      if (this.positionid === '') {
        this.$message({
          type: 'error',
          message: '未选择职位'
        })
      } else {
        if (this.oldPosition !== this.positionid) {
          const data = {
            userid: this.uid,
            positionid: this.positionid[2]
          }
          editUserPosition(data).then(response => {
            this.getUserDetail()
            this.$message({
              type: 'success',
              message: '修改成功!该员工重新登录后生效'
            })
            this.oldPosition = this.positionid
            this.isEditPosition = false
          })
        } else {
          this.$message({
            type: 'error',
            message: '请勿选择相同职位'
          })
        }
      }
    },
    closeUserPosition() {
      this.isEditPosition = false
    },
    changeUserDept() {
      this.isEditDept = true
    },
    editUserDept() {
      if (this.deptid === '') {
        this.$message({
          type: 'error',
          message: '未选择部门'
        })
      } else {
        if (this.olddeptid !== this.deptid) {
          const data = {
            userid: this.uid,
            deptid: this.deptid[(this.deptid.length - 1)],
            groupid: this.deptid[0]
          }
          editUserDept(data).then(response => {
            this.getUserDetail()
            this.$message({
              type: 'success',
              message: '修改成功!'
            })
            this.olddeptid = this.deptid
            this.isEditDept = false
          })
        } else {
          this.$message({
            type: 'error',
            message: '请勿选择相同部门'
          })
        }
      }
    },
    closeUserDept() {
      this.isEditDept = false
    },
    formatSeconds(value) {
      let theTime = parseInt(value)// 秒
      let middle = 0// 分
      let hour = 0// 小时
      if (theTime > 60) {
        middle = parseInt(theTime / 60)
        theTime = parseInt(theTime % 60)
        if (middle > 60) {
          hour = parseInt(middle / 60)
          middle = parseInt(middle % 60)
        }
      }
      let result = '' + parseInt(theTime) + '秒'
      if (middle > 0) {
        result = '' + parseInt(middle) + '分' + result
      }
      if (hour > 0) {
        result = '' + parseInt(hour) + '小时' + result
      }
      return result
    },
  }
}
</script>

<style lang="scss" scoped>
  .user-item{
    color:#99a9bf;
    margin-bottom: 20px;
    font-size: 13px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    span{
      font-weight: 400;
      color: #606266;
    }
    i{
      margin-right: 5px;
    }
  }
  .el-radio__label {
    font-size: 13px;
  }
</style>
